<template>
  <div
    v-if="isLoading"
    class="loader-container"
  >
    <div class="loader" />
  </div>
</template>

<script>
import { useLoaderStore } from '../../store/loader.js';

export default {
  computed: {
    isLoading() {
      return useLoaderStore().isLoading;
    },
  },
};
</script>

<style scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
